import { useCallback } from 'react';

import useMode from '../stores/mode';
import useMarker from '../stores/marker';

import ItemVideo from './ItemVideo';
import ItemChat from './ItemChat';
import Back from './Back';

function Item() {
    const mode = useMode();
    const marker = useMarker();

    const _Item = useCallback(() => {
        switch (marker.getCurrent()?.type) {
            case 'video':
                return <ItemVideo item={marker.getCurrent()}></ItemVideo>;
                break;

            case 'chat':
                return <ItemChat item={marker.getCurrent()}></ItemChat>;
                break;
        }
    }, [marker]);

    return (
        <section className={`Item Item${marker.getCurrent()?.type.replace(/^\w/, (c) => c.toUpperCase())}`}>
            {_Item()}

            <Back></Back>
        </section>
    );
}

export default Item;
